import type { ReactNode } from "react";
import { Theme, useThemeName } from "tamagui";
import type { GlassAppearance } from "./types";

/**
 * Pins the glass theme values to light or dark; `auto` inherits. Works under
 * the `v2` and `light` roots alike: dark is the root's `inverse` child, light
 * is the root itself.
 */
export const GlassTheme = ({
  appearance,
  children
}: {
  appearance: GlassAppearance;
  children: ReactNode;
}) => {
  const current = useThemeName();
  const root = current.startsWith("v2") ? "v2" : "light";
  const isDark = current.endsWith("_inverse");
  if (appearance === "auto" || appearance === "dark" === isDark) {
    return children;
  }
  return <Theme name={appearance === "dark" ? `${root}_inverse` : root} forceClassName data-sentry-element="Theme" data-sentry-component="GlassTheme" data-sentry-source-file="GlassTheme.tsx">
      {children}
    </Theme>;
};